import React, { useEffect, useState } from "react";
import Nav from "./Nav";
import DropdownRight from "./DropdownRight";
import http from "../services/http";
import { Table, Switch } from "antd";
import { showToast } from "./ShowToast";
import { ToastContainer } from "react-toastify";
import { render } from "@testing-library/react";

const SearchApp = ({ data, loading, pagen, lastPage, handlePermissionChange }) => {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  let videosDownloadPermissionsDataList = data;

  const handleChange = (event) => {
    let searchValue = event.target.value;
    setPage(0);
    setSearch(searchValue);
  };
  const handlePage = (page) => {
    setPage(page);
  };

  let searchString = search.trim().toLowerCase();

  if (searchString.length > 0) {
    videosDownloadPermissionsDataList = videosDownloadPermissionsDataList.filter(
      (e) =>
        e?.name?.toLowerCase().includes(searchString) ||
        e?.email.toLowerCase().includes(searchString) ||
        e?.teamName?.toLowerCase().includes(searchString) 
    );
  }

  return (
    <div className="wrapper">
      <Nav />
      <div id="content">
        <header>
          <div className="dashboard_header">
            <div className="left-side d-flex ">
              <h1>Restore Tablet Permission</h1>
            </div>
            <div className="user_profile">
              <DropdownRight />
            </div>
          </div>
        </header>
        <UserInput
          update={(e) => handleChange(e)}
          handlePage={(page) => handlePage(page)}
        />
        <TableComponent
          data={videosDownloadPermissionsDataList}
          loading={loading}
          page={page}
          handlePage={(page) => handlePage(page)}
          lastPage={lastPage}
          lastPageNumber={pagen}
          handlePermissionChange={handlePermissionChange}
        />
      </div>
    </div>
  );
};

const TableComponent = ({ loading, data, handlePermissionChange }) => {
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      sorter: (a, b) => a.email.localeCompare(b.email),
    },
    {
      title: "Team Name",
      dataIndex: "teamName",
      key: "teamName",
      sorter: (a, b) => a.teamName.localeCompare(b.teamName),
    },
    {
      title: "Coach Type",
      dataIndex: "type",
      key: "type",
      sorter: (a, b) => a.type.localeCompare(b.type),
    },
    {
      title: "Restore Tablet Permission",
      dataIndex: "videosDownloadPermissions",
      key: "videosDownloadPermissions",
      render: (value, record) => (
        <Switch
          checked={value === 1}
          onChange={(checked) => handlePermissionChange(record.id, checked ? 1 : 0)}
          style={{
            backgroundColor: value === 1 ? "#4CAF50" : "#ccc",
            borderColor: value === 1 ? "#4CAF50" : "#ccc"
          }}
        />
      ),
    }
];

  return (
    <div className="table_vedio_upload dashbord_table team_table mb_30 over_flow mb-0">
      <Table
        className="table table-borderless table-responsive-md"
        columns={columns}
        // rowSelection={{ ...rowSelection, checkStrictly }}
        dataSource={data}
        loading={loading}
        pagination={{ defaultPageSize: 10 }}
        rowKey="id"
      />
      <ToastContainer />
    </div>
  );
};

const UserInput = ({ update, handlePage }) => {
  return (
    <div className="analysts-wraper-head">
      <div className="form-group search_wraper">
        <input
          onChange={(e) => {
            update(e);
            handlePage(0);
          }}
          name=""
          className="form-control custom_input"
          placeholder="Search by Name,Email,Team Name"
        />
      </div>
    </div>
  );
};

export default function CoachVideosPermissions() {
  const token = localStorage.getItem("xAuthToken");
  const [coachVideosPermissionsData, setCoachVideosPermissionsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [lastPageNumber, setLastPageNumber] = useState(0);
  const [lastPage, setLastPage] = useState(0);
  const usersPerPage = 7;


  useEffect(() => {
    getAllCoachVideosPermissionsDetails();
  }, []);

  const getAllCoachVideosPermissionsDetails = async () => {
    setLoading(true);

    http
      .get(`api/admin/coach/videos-permissions/list?token=${token}`)
      .then((res) => {
        setLoading(false);
        setCoachVideosPermissionsData(res.data.data);
        setLastPageNumber(res.data.data.length % usersPerPage);
        setLastPage(Math.ceil(res.data.data.length / usersPerPage));
      })
      .catch((error) => {
        setLoading(false);
        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              setError(error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            setError(error.response.data.message);
          }
        }
      });
  };

  const handlePermissionChange = async (coachId, newPermissionValue) => {
    setLoading(true);

    http
      .put(`api/admin/coach/update-videos-permissions/${coachId}?token=${token}`,{videosDownloadPermissions: newPermissionValue})
      .then((res) => {
        showToast("success", res.data.message);
        getAllCoachVideosPermissionsDetails();
      })
      .catch((error) => {
        setLoading(false);
        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              setError(error.response.data.errors[key]);
              showToast("error", error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            showToast("error", error.response.data.message);
          }
        }
      });

  };

  return (
    <>
      <SearchApp
        data={coachVideosPermissionsData}
        loading={loading}
        pagen={lastPageNumber}
        lastPage={lastPage}
        handlePermissionChange={handlePermissionChange}
      />
    </>
  );
}
